import api from './api';

export interface FormacaoAcademica {
  id: number;
  valor: string;
  descricao?: string;
}

export const formacoesAcademicasService = {
  async findAll(): Promise<FormacaoAcademica[]> {
    // Usar a mesma API que o scheduling usa
    const response = await api.get<FormacaoAcademica[]>('/domain/academic-formation');
    return response.data;
  },
};

